export enum FieldType {
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  USER = 'USER',
  CHECKBOX = 'CHECKBOX',
  NUMBER = 'NUMBER',
}
